import React from 'react';

const WobbleSticks = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 86.065 83.025"
			className={className}
		>
			<g fill="currentColor">
				<path d="M8.83 46.009V55h8.509v15.875h15.627V54.332a13.188 13.188 0 0 0 9.317-8.25H64.25a3.286 3.286 0 0 0 .657.955 3.244 3.244 0 0 0 2.3.951h12.942a5.927 5.927 0 0 0 5.926-5.926v-1.1a5.927 5.927 0 0 0-5.926-5.926H67.197a3.237 3.237 0 0 0-2.3.951 3.2 3.2 0 0 0-.657.955H42.284a13.185 13.185 0 0 0-9.319-8.25V12.149H17.338v15.875H8.829v8.991H0v8.994h8.828Zm54.947-2.217H43.399a13.166 13.166 0 0 0 0-4.556h20.378v4.558Zm-23.416-5.38a10.921 10.921 0 0 1 0 6.2 10.894 10.894 0 0 1-7.329 7.335V31.082a10.89 10.89 0 0 1 7.329 7.329ZM12.65 31.843h8.509V15.968h7.991v51.085h-7.988V51.179H12.65V31.845Zm-3.82 7.466v4.409H2.293v-4.409Z" />
				<path d="M50.826 4.253a31.514 31.514 0 0 1 15.61 14.149l-2.662 1.09 5.786 4.469.978-7.247-2.687 1.1A33.034 33.034 0 0 0 51.265 2.78L52.098 0l-7.113 1.688 5.019 5.318Z" />
				<path d="m67.858 65.209 2.687 1.1-.978-7.247-5.786 4.469 2.656 1.09a31.5 31.5 0 0 1-15.61 14.147l-.823-2.754-5.019 5.318 7.113 1.688-.832-2.774a33.039 33.039 0 0 0 16.591-15.035Z" />
				<path d="M16.452 35.067a1.115 1.115 0 1 0 .789.327 1.119 1.119 0 0 0-.789-.327Z" />
				<path d="M16.452 45.826a1.115 1.115 0 1 0 .789.327 1.119 1.119 0 0 0-.789-.327Z" />
			</g>
		</svg>
	);
};

export default WobbleSticks;
